import { render, staticRenderFns } from "./magazineListEdit.vue?vue&type=template&id=f9f2c2a4&scoped=true&"
import script from "./magazineListEdit.vue?vue&type=script&lang=js&"
export * from "./magazineListEdit.vue?vue&type=script&lang=js&"
import style0 from "./magazineListEdit.vue?vue&type=style&index=0&id=f9f2c2a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f2c2a4",
  null
  
)

export default component.exports